<div class="d-flex gap-2 align-items-center" [ngClass]="class">
  <svg-icon [src]="'assets/icons/' + icon + '.svg'"></svg-icon>
  <div class=""  >{{ text }}</div>
</div>
